import {makeStyles} from "@mui/styles";

export const useStyles = makeStyles({
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 16
  }
});
